<app-popup-layout #modal>
  <header class="modal-header">
    <app-close-button
      class="ms-auto"
      (onCloseEmitter)="modal.dismiss()"
    ></app-close-button>
  </header>
  <div class="modal-container">
    <div class="left-section mt-2">
      <p class="title mt-2">EnKash Meal Card</p>
      <p class="sub-title px-24 mb-0">
        EnKash meal card is a complete digital solution for corporates. Meal
        card can be used at all food and beverage merchant outlets, including
        restaurants, sweet shops. Similar to Debit or Credit card, EnKash meal
        card helps you administer meals to employees in a hassle free manner.
      </p>

      <div class="md-stepper-horizontal">
        <div class="md-step">
          <div class="circle">
            <div class="inner-circle"></div>
          </div>
          <div class="stepper-text mt-3 mx-3">Configure Meal Account</div>
          <div class="md-step-bar-left"></div>
          <div class="md-step-bar-right"></div>
        </div>
        <div class="md-step">
          <div class="circle">
            <div class="inner-circle"></div>
          </div>
          <div class="stepper-text mt-3 mx-3">
            Control & Configure Meal Card
          </div>
          <div class="md-step-bar-left"></div>
          <div class="md-step-bar-right"></div>
        </div>
        <div class="md-step">
          <div class="circle">
            <div class="inner-circle"></div>
          </div>
          <div class="stepper-text mt-3 mx-3">Track Expenditure</div>
          <div class="md-step-bar-left"></div>
          <div class="md-step-bar-right"></div>
        </div>
      </div>

      <section class="d-flex flex-col align-items-center">
        <p class="mb-2 exp-text">
          Want to experience the benefits of Meal Cards?
        </p>

        <button
          mat-flat-button
          color="primary"
          class="custom-button"
          (click)="onSetup()"
          [appLoaderButton]="formActionRequestState()"
        >
          {{ title }}
        </button>
      </section>
    </div>

    <div class="right-section">
      <img
        src="assets/home/enkash-meal-card.png"
        class="meal-card-enkash"
        alt="Enkash Meal Card"
      />
    </div>
  </div>
  <div class="footer pb-12">
    <p class="footer-title mt-2 mb-16">Key features of EnKash Meal Card</p>
    <section class="footer-grouping">
      <section class="footer-header">
        <img
          src="assets/home/flexibility-home.svg"
          class="footer-img"
          alt="Flexibility"
        />
        <p class="footer-header-title mb-0">Flexibility</p>
        <p class="footer-header-sub-title mx-3">
          Ease of onboarding, advance controls for admin to allocate balance on
          the fly
        </p>
      </section>

      <section class="footer-header">
        <img
          src="assets/home/convenience-home.svg"
          class="footer-img"
          alt="Convenience"
        />
        <p class="footer-header-title mb-0">Convenience</p>
        <p class="footer-header-sub-title">
          Instant capture of meal transactions available for view and download
        </p>
      </section>

      <section class="footer-header">
        <img
          src="assets/home/diy-control-home.svg"
          class="footer-img"
          alt="DIY Controls"
        />
        <p class="footer-header-title mb-0">DIY Controls</p>
        <p class="footer-header-sub-title mx-3">
          Simple, easy to use controls for controlling the meal card
        </p>
      </section>

      <section class="footer-header px-3">
        <img
          src="assets/home/analytics-home.svg"
          class="footer-img"
          alt="Analytics"
        />
        <p class="footer-header-title mb-0">Analytics</p>
        <p class="footer-header-sub-title">
          Spend analytics offers insights on the meal card usage and acceptance
        </p>
      </section>
    </section>
  </div>
</app-popup-layout>
